/**
 * @generated SignedSource<<cd66ea37395783ccce3ba4f21c2e2fb6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OccurrencesModal_salesAssociate$data = {
  readonly " $fragmentSpreads": FragmentRefs<"OccurrencesContentTemplate_salesAssociate" | "MultipleAssistancesContentTemplate_salesAssociate" | "SalesAssociatesContentTemplate_salesAssociate">;
  readonly " $fragmentType": "OccurrencesModal_salesAssociate";
};
export type OccurrencesModal_salesAssociate$key = {
  readonly " $data"?: OccurrencesModal_salesAssociate$data;
  readonly " $fragmentSpreads": FragmentRefs<"OccurrencesModal_salesAssociate">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OccurrencesModal_salesAssociate",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "OccurrencesContentTemplate_salesAssociate"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MultipleAssistancesContentTemplate_salesAssociate"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SalesAssociatesContentTemplate_salesAssociate"
    }
  ],
  "type": "SalesAssociate",
  "abstractKey": null
};

(node as any).hash = "e3bed8ea2769e991bb43ac87d3345808";

export default node;
